import Header from '../components/header';
import Footer from '../components/footer'
import React from 'react';
import '../index.css';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { FaAward, FaLink } from 'react-icons/fa';
import { getCertificatesData } from '../data/certificateData'
import placeholder from '../assets/images/image2.png';

function Certificates() {
    const certifications = getCertificatesData()

    return (
        <>
            <Header />

            <Container className="certi-container fade-in-up gap-3 p-3">
                <Row className="justify-content-center p-3 mb-3">
                    <Col className="text-start d-flex align-items-center justify-content-start">
                        <FaAward className='page-img'></FaAward>
                        <h2 className="heading m-0">MILESTONES</h2>
                    </Col>
                </Row>
                {certifications.map(certification => (
                    <Row key={certification.id} className="my-card w-lg-100 certi d-flex align-items-center justify-content-center p-3 mb-4">
                        <Col lg={3} md={3} className="text-end d-none d-md-block">
                            <div className='certi-wrapper'>
                                <Image
                                    src={certification.img || placeholder}
                                    alt={certification.title}
                                    className="certi-img"
                                    fluid
                                />
                                <div className="certi-overlay">
                                    <a href={certification.link} target="_blank" rel="noopener noreferrer">{certification.title}</a>
                                </div>
                            </div>
                        </Col>
                        <Col lg={9} md={9}>
                            <Row>
                                <Col lg={12} className="text-start">
                                    <h3 className="heading3">{certification.title}
                                        <a href={certification.link} className="mx-2" target="_blank" rel="noopener noreferrer">
                                            <FaLink />
                                        </a>
                                    </h3>
                                    <p className="m-0 mb-3 heading4">{certification.issuer}</p>
                                    <p className="m-0 mb-3">{certification.monthYear}</p>
                                </Col>
                                <Col lg={12} className="text-start d-md-none">
                                    <div className='certi-wrapper'>
                                        <Image
                                            src={certification.img || placeholder}
                                            alt={certification.title}
                                            className="certi-img w-100"
                                            fluid
                                        />
                                        <div className="certi-overlay">
                                            <a href={certification.link} target="_blank" rel="noopener noreferrer">{certification.title}</a>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={12} className=" mt-2">
                                    <ul className='my-2'>
                                        {certification.whatLearned.split('. ').map((subject, index) => (
                                            <li key={index}>{subject}</li>
                                        ))}
                                    </ul>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                ))}
            </Container>

            <Footer />
        </>
    );
}

export { Certificates };
